/* defaultLogger.js */

"use strict";
const Steve = require("@gluenetworks/steve_core");
const _ = require("lodash");
let Logger;
if (_.isFunction(Steve.getInstance)) {
    Logger = Steve.getInstance().logger;
}
module.exports = Logger;
